// The payload is the deleted facility's id, wrapped in an object: synapse's `DefaultPayload` requires
// `payload` to be a record (or an array of records), never a bare primitive.
export type FacilityDeletedPayload = {
	facilityId: number;
};

export type FacilityDeletedAction = {
	type: 'FACILITY_DELETED';
	payload: FacilityDeletedPayload;
	organizationId: number;
};

export default (payload: FacilityDeletedPayload, organizationId: number): FacilityDeletedAction => ({
	type: 'FACILITY_DELETED',
	payload,
	organizationId,
});
